// extracted by mini-css-extract-plugin
export default {"altVariantLink":"SignInPage_altVariantLink_2eX1H"};